module.exports = __webpack_public_path__ + "img/66.2cb89c16.jpg";